import style from "@/elements-react/logistic-and-delivery/style.module.scss";
import classNames from "classnames";
import planeIcon from "@/assets/logistic-and-delivery/plane.svg";
import boxIcon from "@/assets/logistic-and-delivery/box.svg";
import locationIcon from "@/assets/logistic-and-delivery/location.svg";
import arrowRightIcon from "@/assets/arrow-right.svg";
import { Icon } from "@/elements-react/fix-icon";
import { Url } from "@/helpers/url";
import { useTranslation } from "react-i18next";
import { FixLink } from "@/elements-react/fix-link";

export const LogisticAndDeliveryDesktopBlackAndBlue = () => {
  const { t } = useTranslation();

  return (
    <div className={classNames(style.container)}>
      <div>
        <h2 className={classNames(style.title)}>{t("logisticAndDelivery.title", "Logistics & Delivery")}</h2>
        <div className={classNames(style.description)}>
          {t("logisticAndDelivery.description", "We don't just sell parts, we deliver solutions. Fast shipping from our own central hub to your garage")}
        </div>
      </div>
      <div className={classNames(style.highlightsContainer)}>
        <div className={classNames(style.highlightBox)}>
          <div className={classNames(style.iconBox)}>
            <Icon src={planeIcon} width={48} height={48} />
          </div>
          <div>
            <div className={classNames(style.highlightTitle)}>{t("logisticAndDelivery.shippingGlobally.title", "Shipping globally via air & sea freight")}</div>
            <div className={classNames(style.highlightDesc)}>
              {t(
                "logisticAndDelivery.shippingGlobally.description",
                "Choose express air freight for urgent repairs or economical sea shipping for heavy components. We deliver to over 150 countries",
              )}
            </div>
          </div>
        </div>
        <div className={classNames(style.highlightBox)}>
          <div className={classNames(style.iconBox)}>
            <Icon src={boxIcon} width={48} height={48} />
          </div>
          <div>
            <div className={classNames(style.highlightTitle)}>{t("logisticAndDelivery.directDelivery.title", "Direct delivery")}</div>
            <div className={classNames(style.highlightDesc)}>
              {t(
                "logisticAndDelivery.directDelivery.description",
                "No middlemen, no dropshipping delays. Your part is picked, packed, and shipped directly from our facility to your doorstep",
              )}
            </div>
          </div>
        </div>
        <div className={classNames(style.highlightBox)}>
          <div className={classNames(style.iconBox)}>
            <Icon src={locationIcon} width={48} height={48} />
          </div>
          <div>
            <div className={classNames(style.highlightTitle)}>{t("logisticAndDelivery.warehouseLatvia.title", "Warehouse in Latvia")}</div>
            <div className={classNames(style.highlightDesc)}>
              {t(
                "logisticAndDelivery.warehouseLatvia.description",
                "Strategically located in the EU. This ensures duty-free shipping within Europe and rapid connection to global transit hubs",
              )}
            </div>
          </div>
        </div>
      </div>
      <div>
        <FixLink className={style.link} href={Url.to("help-page", { section: "delivery-time" })}>
          {t("logisticAndDelivery.moreAboutDelivery", "More about delivery")}
          <Icon src={arrowRightIcon} height={16} width={16} />
        </FixLink>
      </div>
    </div>
  );
};

export const LogisticAndDeliveryMobileBlackAndBlue = () => {
  const { t } = useTranslation();

  return (
    <div className={classNames(style.container, style.mobile)}>
      <div>
        <h3 className={classNames(style.title)}>{t("logisticAndDelivery.title", "Logistics & Delivery")}</h3>
        <div className={classNames(style.description)}>
          {t("logisticAndDelivery.description", "We don't just sell parts, we deliver solutions. Fast shipping from our own central hub to your garage")}
        </div>
      </div>
      <div className={classNames(style.highlightsContainer)}>
        <div className={classNames(style.highlightBox)}>
          <div className={classNames(style.iconBox)}>
            <Icon src={planeIcon} width={32} height={32} />
          </div>
          <div className={classNames(style.highlightTextBox)}>
            <div className={classNames(style.highlightTitle)}>{t("logisticAndDelivery.shippingGlobally.title", "Shipping globally via air & sea freight")}</div>
            <div className={classNames(style.highlightDesc)}>
              {t(
                "logisticAndDelivery.shippingGlobally.description",
                "Choose express air freight for urgent repairs or economical sea shipping for heavy components. We deliver to over 150 countries",
              )}
            </div>
          </div>
        </div>
        <div className={classNames(style.highlightBox)}>
          <div className={classNames(style.iconBox)}>
            <Icon src={boxIcon} width={32} height={32} />
          </div>
          <div className={classNames(style.highlightTextBox)}>
            <div className={classNames(style.highlightTitle)}>{t("logisticAndDelivery.directDelivery.title", "Direct delivery")}</div>
            <div className={classNames(style.highlightDesc)}>
              {t(
                "logisticAndDelivery.directDelivery.description",
                "No middlemen, no dropshipping delays. Your part is picked, packed, and shipped directly from our facility to your doorstep",
              )}
            </div>
          </div>
        </div>
        <div className={classNames(style.highlightBox)}>
          <div className={classNames(style.iconBox)}>
            <Icon src={locationIcon} width={32} height={32} />
          </div>
          <div className={classNames(style.highlightTextBox)}>
            <div className={classNames(style.highlightTitle)}>{t("logisticAndDelivery.warehouseLatvia.title", "Warehouse in Latvia")}</div>
            <div className={classNames(style.highlightDesc)}>
              {t(
                "logisticAndDelivery.warehouseLatvia.description",
                "Strategically located in the EU. This ensures duty-free shipping within Europe and rapid connection to global transit hubs",
              )}
            </div>
          </div>
        </div>
      </div>
      <div>
        <FixLink className={style.link} href={Url.to("help-page", { section: "delivery-time" })}>
          {t("logisticAndDelivery.moreAboutDelivery", "More about delivery")}
          <Icon src={arrowRightIcon} height={16} width={16} />
        </FixLink>
      </div>
    </div>
  );
};
